module.exports = __webpack_public_path__ + "static/media/play.4ea3d710.svg";